import { freightHandlingUnitIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const deleteFreightHandlingUnit = {
  name: "deleteFreightHandlingUnit" as const,
  input: z.object({ id: freightHandlingUnitIdFormat.schema }),
  output: z.object({}),
};
